import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from "@angular/core";
import { MediaPlayer } from "../../media-player";

/* eslint-disable @angular-eslint/no-host-metadata-property */
@Component({
  selector: "video-player[title]",
  templateUrl: "./video-player.component.html",
  styleUrls: ["../../styles/media-player.scss"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: "video-player"
  }
})
export class VideoPlayerComponent extends MediaPlayer {
  @Input() displayFullscreenControl = true;
  @Input() title: string;
}
